import axios from "axios"

const controller = "/asignacionItems"

const AsignacionItemsService = {

    obtenerTipos: async () => {
        const { data } = await axios.post(`${controller}/obtenerTipos`)
        return data
    },
    obtenerEstados: async () => {
        const { data } = await axios.post(`${controller}/obtenerEstados`)
        return data
    },
    obtenerAlmacenes: async (request) => {
        const { data } = await axios.post(`${controller}/obtenerAlmacenes`, request)
        return data
    },
    buscarEmpleado: async (request) => {
        const { data } = await axios.post(`${controller}/buscarEmpleado`, request)
        return data
    },
    buscar: async (request) => {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    registrar: async (request) => {
        const { data } = await axios.post(`${controller}/registrar`, request)
        return data
    },
    obtener: async (request) => {
        const { data } = await axios.post(`${controller}/obtener`, request)
        return data
    },
    eliminar: async (request) => {
        const { data } = await axios.post(`${controller}/eliminar`, request)
        return data
    },
    buscarDetalle: async (request) => {
        const { data } = await axios.post(`${controller}/buscarDetalle`, request)
        return data
    },
    buscarAsignacionesxItems: async (request) => {
        const { data } = await axios.post(`${controller}/buscarAsignacionesxItems`, request)
        return data
    },

}

export default AsignacionItemsService